import { ReactiveSet } from "@solid-primitives/set";
import { File } from "../classes/File.js";
export const channelHydration = {
    keyMapping: {
        _id: "id",
        channel_type: "channelType",
        recipients: "recipientIds",
        user: "userId",
        owner: "ownerId",
        server: "serverId",
        default_permissions: "defaultPermissions",
        role_permissions: "rolePermissions",
        last_message_id: "lastMessageId",
    },
    functions: {
        id: (channel) => channel._id,
        channelType: (channel) => channel.channel_type,
        name: (channel) => channel.name,
        description: (channel) => channel.description,
        icon: (channel, ctx) => new File(ctx, channel.icon),
        active: (channel) => channel.active || false,
        typingIds: () => new ReactiveSet(),
        recipientIds: (channel) => new ReactiveSet(channel.recipients),
        userId: (channel) => channel.user,
        ownerId: (channel) => channel.owner,
        serverId: (channel) => channel.server,
        permissions: (channel) => BigInt(channel.permissions),
        defaultPermissions: (channel) => ({
            a: BigInt(channel.default_permissions?.a ?? 0),
            d: BigInt(channel.default_permissions?.d ?? 0),
        }),
        rolePermissions: (channel) => Object.fromEntries(Object.entries(channel.role_permissions ?? {}).map(([k, v]) => [
            k,
            {
                a: BigInt(v.a),
                d: BigInt(v.d),
            },
        ])),
        nsfw: (channel) => channel.nsfw || false,
        lastMessageId: (channel) => channel.last_message_id,
        voice: (channel) => !!channel.voice || channel.channel_type === 'DirectMessage' || channel.channel_type === 'Group' ? ({
            maxUsers: channel.voice?.max_users || undefined,
        }) : undefined,
    },
    initialHydration: () => ({
        typingIds: new ReactiveSet(),
        recipientIds: new ReactiveSet(),
    }),
};
